import { render, staticRenderFns } from "./SpecItem.vue?vue&type=template&id=bf748af8&"
import script from "./SpecItem.vue?vue&type=script&lang=js&"
export * from "./SpecItem.vue?vue&type=script&lang=js&"
import style0 from "./SpecItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports